import { SmsCountry } from "@ua/web-sdk/lib/plugins/subscription-form/types"

/**
 * load globals that are written into the index file by webpack; see index.ejs
 * for further information
 */
type WindowGlobals = {
  sdkBaseUrl: string
  emailEnabled: string
  smsEnabled: string
  smsSenderId: string
  smsCountry?: SmsCountry
  preferenceCenterId: string
  appKey: string
  loadMinifiedPlugins: boolean
}

const WINDOW_GLOBAL_PROPERTY_NAME = "_UA_GLOBAL"

const {
  sdkBaseUrl,
  emailEnabled,
  smsEnabled,
  smsSenderId,
  smsCountry,
  preferenceCenterId,
  appKey,
  loadMinifiedPlugins,
}: WindowGlobals = (window as any)[WINDOW_GLOBAL_PROPERTY_NAME]

export {
  sdkBaseUrl,
  emailEnabled,
  smsEnabled,
  smsSenderId,
  smsCountry,
  preferenceCenterId,
  appKey,
  loadMinifiedPlugins,
}
